import React from 'react';
// import UserImg from 'assets/user.png';

const UserInfo = ({
  name,
  contactName = '',
  mobileNumber = '',
  gstNumber = '',
}) => {
  return (
    <div className="user-info d-flex align-items-center">
      {/* <div className="img-wrap rounded-circle">
                <img src={UserImg} alt="user" />
            </div> */}
      <div className="info">
        <h4
          className="f-12 fw-medium mb-0 text-dark text-capitalize"
          title={name}
        >
          {name}
        </h4>
        {contactName && (
          <p className="mb-0 mt-1 f-12 font-manrope text-dark">{contactName}</p>
        )}
        {mobileNumber && (
          <p className="mb-0 mt-1 f-12 font-manrope text-active">
            {mobileNumber}
          </p>
        )}
        {gstNumber && (
          <p className="mb-0 mt-1 f-12 font-manrope text-active">{gstNumber}</p>
        )}
      </div>
    </div>
  );
};

export default UserInfo;
